import Body from 'molecules/seo-establishment-card/body';
import { establishmentImagesInterface } from 'constants/interfaces';
import { PropTypes } from 'prop-types';
import React from 'react';
import Top from 'molecules/seo-establishment-card/top';


export const SEO_ESTABLISHMENT_CARD_CLICK_SECTIONS = {
  SEO: 5,
};
export const SEO_ESTABLISHMENT_CARD_CLICK_SUBSECTIONS = {
  CTA: 6,
  IMAGES: 4,
  SLIDE_CHANGE: 'SLIDE_CHANGE',
  TITLE: 0,
};

export default function SeoEstablishmentCard({ area, city, className, clickinHref, comments, estabFallbackImages, establishment,
  establishmentImages, establishmentTitle, establishmentType, guests, handleOnClick, hasPrice, isFollow, rating, t, titlePreposition }) {
  return (
    <li className="landing-page__establishments__list">
      <section
        className={ `ak-establishment-card ${className}` }
      >
        <Top
          alt={ establishmentImages.length ? establishmentImages[0].alt : '' }
          estabFallbackImages={ estabFallbackImages }
          href={ clickinHref }
          id={ establishment.id }
          image={ establishmentImages.length ? establishmentImages[0].url : '' }
          isFollow={ isFollow }
          t={ t }
        />
        <Body
          area={ area }
          city={ city }
          clickinHref={ clickinHref }
          comments={ comments }
          establishmentTitle={ establishmentTitle }
          establishmentType={ establishmentType }
          guests={ guests }
          handleOnClick={ handleOnClick }
          hasPrice={ hasPrice }
          isFollow={ isFollow }
          rating={ rating }
          t={ t }
          titlePreposition={ titlePreposition }
        />
      </section>
    </li>
  );
}

SeoEstablishmentCard.defaultProps = {
  area: null,
  city: null,
  className: '',
  hasPrice: null,
  rating: null,
  titlePreposition: null,
};

SeoEstablishmentCard.propTypes = {
  area: PropTypes.number,
  city: PropTypes.string,
  className: PropTypes.string,
  clickinHref: PropTypes.string.isRequired,
  comments: PropTypes.number.isRequired,
  estabFallbackImages: PropTypes.arrayOf(PropTypes.string).isRequired,
  establishment: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
  establishmentImages: PropTypes.arrayOf(establishmentImagesInterface).isRequired,
  establishmentTitle: PropTypes.string.isRequired,
  establishmentType: PropTypes.number.isRequired,
  guests: PropTypes.number.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  hasPrice: PropTypes.bool,
  isFollow: PropTypes.bool.isRequired,
  rating: PropTypes.number,
  t: PropTypes.func.isRequired,
  titlePreposition: PropTypes.string,
};
